import { Fragment, useEffect, useLayoutEffect, useState } from "react";
import MainContainer from "../../components/container/MainContainer";
import PageTitle from "../../components/titles/PageTitle";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useAuthorization } from "../../hooks/useAuthorization";
import {
  getOnlyProject,
  getProjectWithMails,
  unsetSelectedProject,
} from "../../features/projectsSlice";
import { getDonor, unsetSelectedDonor } from "../../features/donorsSlice";
import PDFComponent from "../../components/pdf/PDFComponent";
import Loading from "../../components/loading/Loading";
import ProjectTitle from "../../components/text/ProjectTitle";
import Modal from "../../components/modal/Modal";
import SendReformMail from "./SendReformMail";
import { openModal } from "../../features/modalSLice";
import { ChevronLeft, Mail, MailPlus } from "lucide-react";
import SaveEmailRecord from "./SaveEmailRecord";
import useReformulatedData from "../../hooks/useReformulatedData";
import ProposalReformulated from "../../components/projects/ProposalReformulated";
import { useCallback } from "react";
import NetworkError from "../error/NetworkError";
import { setConfigError } from "../../features/configSlice";
import loadStatus from "../../util/loadStatus";

const ReformulationDonor = () => {
  const { id, project_id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { isAuthorized } = useAuthorization();
  const project = useSelector((state) => state.projects.selected); // List of ongoing projects
  const donor = useSelector((state) => state.donors.selected);
  const reformulations = useSelector((state) => state.donors.reformulations);
  const reformulationItems = useSelector(
    (state) => state.config.reformulationItems
  );

  const modalContent = useSelector((state) => state.modal.content);
  const donorLoad = useSelector((state) => state.donors.load.getDonor);
  const projectLoad = useSelector(
    (state) => state.projects.load.getOnlyProject
  );

  // const [data, setData] = useState([]);
  const [file, setFile] = useState(null);

  //Get Blob from Document
  const getBlobFile = async (func) => {
    setFile(await func());
  };

  const openSendMailModal = () => {
    dispatch(
      openModal(
        <SendReformMail
          project_id={project.id}
          donor={donor.name}
          file={file}
          donor_id={id}
          name={project.name}
        />
      )
    );
  };

  const openSaveRecordModal = () => {
    dispatch(
      openModal(
        <SaveEmailRecord
          project_id={project.id}
          donor_id={id}
          name={project.name}
          donor={donor.name}
          type="main"
        />
      )
    );
  };

  const getAllData = useCallback(async () => {
    try {
      await Promise.all([
        dispatch(getOnlyProject(project_id)),
        dispatch(getDonor(id)),
      ]);
    } catch (error) {}
  }, []);

  useLayoutEffect(() => {
    // dispatch(getProjectWithMails({ project_id, donor_id: id }));
    // dispatch(getDonor(id));

    getAllData();
    return () => {
      unsetSelectedDonor();
      // unsetSelectedProject();
    };
  }, []);

  useLayoutEffect(() => {
    if (
      (project.id && project?.stage?.step_number < 12) ||
      (project.id && project?.stage?.step_number > 12)
    ) {
      return navigate("/reformulations/" + project_id, { replace: true });
    }
  }, [project, navigate, reformulations, donor]);

  //Data for pdf files
  const data = useReformulatedData({
    project,
    donor,
    donorLoad,
    reformulationItems,
    reformulations: reformulations || donor.reformulations,
  });

  if (
    !donor.id ||
    donorLoad === loadStatus.loading ||
    projectLoad === loadStatus.loading
  ) {
    return <Loading />;
  }

  if (donorLoad === loadStatus.error || projectLoad === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <MainContainer>
      <Modal>{modalContent}</Modal>
      {donor.id && project.id && (
        <div className="w-full max-w-5xl mx-auto text-text-1/70">
          <div className="sm:flex justify-between items-center py-4">
            <PageTitle title={donor.name + " - Email"} />
          </div>
          {project.id && (
            <div className="mx-auto max-w-5xl w-full bg-content shadow-md px-5 py-6 flex flex-col gap-0.5 ">
              <ProjectTitle title={project.name} />
              <div className="w-full text-text-1/70 bg-bkg border border-bkg2 rounded-md p-3 my-3 sm:flex justify-between items-center">
                <div className="flex sm:mb-0 mb-5">
                  <Link
                    className="cancel-rss-btn"
                    to={"/reformulations/" + project_id}
                  >
                    <ChevronLeft size={18} />
                    Back
                  </Link>
                </div>

                <div className="flex gap-2 items-center justify-end ">
                  <button
                    type="button"
                    onClick={openSendMailModal}
                    className="add-rss-btn"
                    disabled={!isAuthorized("reformulation", "update")}
                  >
                    <Mail size={18} />
                    Mail
                  </button>
                  <button
                    type="button"
                    onClick={openSaveRecordModal}
                    className="add-rss-btn"
                    disabled={!isAuthorized("reformulation", "update")}
                  >
                    <MailPlus size={18} />
                    Record
                  </button>
                  <PDFComponent
                    title={project.name + ", Reformulated Proposal"}
                    data={data}
                    setFile={setFile}
                  />
                </div>
              </div>

              {/* //Reformulated Display */}
              <ProposalReformulated
                project={project}
                reformulationItems={reformulationItems}
                reformulations={reformulations}
              />
            </div>
          )}
          {/* Action Buttons  */}

          <div className="max-w-5xl w-full mx-auto">
            <div className="flex justify-between items-center pt-4 pb-10">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/reformulations/" + project_id);
                }}
                className="cancel-rss-btn"
              >
                <ChevronLeft size={18} />
                Back
              </button>
              <div className="flex gap-2">
                <button
                  type="button"
                  onClick={openSendMailModal}
                  className="add-rss-btn"
                  disabled={!isAuthorized("reformulation", "update")}
                >
                  <Mail size={18} />
                  Mail
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </MainContainer>
  );
};

export default ReformulationDonor;
